// District single sign-on. A provision doc may name the district's identity
// provider in `ssoProviderId` ("saml.…" or "oidc.…"); the email's provision
// decides the sign-in method (see provisionLookup in ./provision.js), so there
// is no "Sign in with X" button.
import {
  OAuthProvider,
  SAMLAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { projectAuth } from "./config";

export const isSsoProviderId = (id) =>
  typeof id === "string" && (id.startsWith("saml.") || id.startsWith("oidc."));

// Popup, not redirect: this app is served from numetrics-cte.firebaseapp.com
// while the auth domain (where the SAML assertion lands) is
// frameworks.numetrics.org — a different site, so a redirect's result can't be
// read back under the browsers' third-party-storage partitioning. The popup
// hands the result to the opener directly. Resolves with the UserCredential.
export const signInWithSso = (providerId) =>
  signInWithPopup(
    projectAuth,
    providerId.startsWith("saml.")
      ? new SAMLAuthProvider(providerId)
      : new OAuthProvider(providerId)
  );

// Firebase does not document emailVerified for SAML users, so a district
// identity provider on the account is what counts as verified.
export const isVerifiedUser = (user) =>
  !!user &&
  (user.emailVerified ||
    user.providerData.some((p) => isSsoProviderId(p.providerId)));
